module.exports = __webpack_public_path__ + "static/media/ensatina.43c05afc.jpg";